import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import { IconButton, Icon, InputAdornment } from "material-ui";
import { DateTimePicker } from "material-ui-pickers";
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import * as moment from "moment";
import "moment/locale/es";

class DateTimePickerCustom extends Component {
    render() {
        const {
            classes,
            disabled,
            format,
            value,
            label,
            setDate,
            displayFormat
        } = this.props;
        return (
            <div className={classes.formDate}>
                <MuiPickersUtilsProvider
                    utils={MomentUtils}
                    moment={moment}
                    locale="es">
                    <DateTimePicker
                        style={{ width: "100%" }}
                        disabled={disabled}
                        value={moment(value, format)}
                        onChange={setDate}
                        format={displayFormat}
                        label={label}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Icon style={{ color: "#333" }}>event</Icon>
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </MuiPickersUtilsProvider>
            </div>
        );
    }
}

const styles = theme => ({
    formDate: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "100%"
    }
});

export default withStyles(styles)(DateTimePickerCustom);



// WEBPACK FOOTER //
// ./src/components/displayComponents/DateTimePickerCustom.js